

























import {Component, Vue} from 'vue-property-decorator';
import LogsCommon from '@/views/logs/LogsCommon.vue';
import LogsLogin from '@/views/logs/LogsLogin.vue';
import LogsError from '@/views/logs/LogsError.vue';

@Component({
  components: {
    LogsCommon,
    LogsLogin,
    LogsError,
  },
})
export default class LogsView extends Vue {
  tab = 0;

  created() {
    document.title = 'Журналы работы системы';
  }
}
